function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import clsx from 'clsx';
import { unstable_composeClasses as composeClasses, unstable_useEventCallback as useEventCallback } from '@mui/utils';
import { styled } from '@mui/system';
import { fastMemo } from '@mui/x-internals/fastMemo';
import { useGridRootProps } from "../hooks/utils/useGridRootProps.js";
import { getDataGridUtilityClass, gridClasses } from "../constants/index.js";
import { useGridApiContext } from "../hooks/utils/useGridApiContext.js";
import { useGridApiEventHandler } from "../hooks/utils/useGridApiEventHandler.js";
import { useGridSelector, useGridSelectorV8 } from "../hooks/utils/useGridSelector.js";
import { gridDimensionsSelector, gridColumnsTotalWidthSelector } from "../hooks/features/dimensions/gridDimensionsSelectors.js";
import { gridDensityFactorSelector } from "../hooks/features/density/densitySelector.js";
import { useTimeout } from "../hooks/utils/useTimeout.js";
import { getTotalHeaderHeight } from "../hooks/features/columns/gridColumnsUtils.js";
import { createSelectorV8 } from "../utils/createSelector.js";
import { jsx as _jsx } from "react/jsx-runtime";
var CLIFF = 1;
var SLOP = 1.5;
var useUtilityClasses = function(ownerState) {
    var scrollDirection = ownerState.scrollDirection, classes = ownerState.classes;
    var slots = {
        root: [
            'scrollArea',
            "scrollArea--".concat(scrollDirection)
        ]
    };
    return composeClasses(slots, getDataGridUtilityClass, classes);
};
var GridScrollAreaRawRoot = styled('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollArea',
    overridesResolver: function(props, styles) {
        return [
            _define_property({}, "&.".concat(gridClasses['scrollArea--left']), styles['scrollArea--left']),
            _define_property({}, "&.".concat(gridClasses['scrollArea--right']), styles['scrollArea--right']),
            styles.scrollArea
        ];
    }
})(function() {
    var _obj;
    return _obj = {
        position: 'absolute',
        top: 0,
        zIndex: 101,
        width: 20,
        bottom: 0
    }, _define_property(_obj, "&.".concat(gridClasses['scrollArea--left']), {
        left: 0
    }), _define_property(_obj, "&.".concat(gridClasses['scrollArea--right']), {
        right: 0
    }), _obj;
});
var offsetSelector = createSelectorV8(gridDimensionsSelector, function(dimensions, direction) {
    if (direction === 'left') {
        return dimensions.leftPinnedWidth;
    }
    if (direction === 'right') {
        return dimensions.rightPinnedWidth + (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    }
    return 0;
});
function GridScrollAreaWrapper(props) {
    var apiRef = useGridApiContext();
    var _React_useState = _sliced_to_array(React.useState(false), 2), dragging = _React_useState[0], setDragging = _React_useState[1];
    useGridApiEventHandler(apiRef, 'columnHeaderDragStart', function() {
        return setDragging(true);
    });
    useGridApiEventHandler(apiRef, 'columnHeaderDragEnd', function() {
        return setDragging(false);
    });
    if (!dragging) {
        return null;
    }
    return /*#__PURE__*/ _jsx(GridScrollAreaContent, _extends({}, props));
}
function GridScrollAreaContent(props) {
    var scrollDirection = props.scrollDirection, scrollPosition = props.scrollPosition;
    var rootRef = React.useRef(null);
    var apiRef = useGridApiContext();
    var timeout = useTimeout();
    var densityFactor = useGridSelector(apiRef, gridDensityFactorSelector);
    var columnsTotalWidth = useGridSelector(apiRef, gridColumnsTotalWidthSelector);
    var sideOffset = useGridSelectorV8(apiRef, offsetSelector, scrollDirection);
    var getCanScrollMore = function() {
        var dimensions = gridDimensionsSelector(apiRef.current.state);
        if (scrollDirection === 'left') {
            // Only render if the user has not reached yet the start of the list
            return scrollPosition.current.left > 0;
        }
        if (scrollDirection === 'right') {
            // Only render if the user has not reached yet the end of the list
            var maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
            return scrollPosition.current.left < maxScrollLeft;
        }
        return false;
    };
    var _React_useState = _sliced_to_array(React.useState(getCanScrollMore), 2), canScrollMore = _React_useState[0], setCanScrollMore = _React_useState[1];
    var rootProps = useGridRootProps();
    var ownerState = _extends({}, rootProps, {
        scrollDirection: scrollDirection
    });
    var classes = useUtilityClasses(ownerState);
    var totalHeaderHeight = getTotalHeaderHeight(apiRef, rootProps);
    var headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    var style = {
        height: headerHeight,
        top: totalHeaderHeight - headerHeight
    };
    if (scrollDirection === 'left') {
        style.left = sideOffset;
    } else if (scrollDirection === 'right') {
        style.right = sideOffset;
    }
    var handleScrolling = function() {
        setCanScrollMore(getCanScrollMore);
    };
    var handleDragOver = useEventCallback(function(event) {
        var offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'left') {
            offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        } else if (scrollDirection === 'right') {
            offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        } else {
            throw new Error('MUI X: Wrong drag direction');
        }
        offset = (offset - CLIFF) * SLOP + CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, function() {
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    });
    useGridApiEventHandler(apiRef, 'scrollPositionChange', handleScrolling);
    if (!canScrollMore) {
        return null;
    }
    return /*#__PURE__*/ _jsx(GridScrollAreaRawRoot, {
        ref: rootRef,
        className: clsx(classes.root),
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: style
    });
}
export var GridScrollArea = fastMemo(GridScrollAreaWrapper);
